import React, { useState } from 'react'
import { Card, ContentSectionBlock, DetailList, Icon, Button } from 'camino-react'
import { find, indexOf, map, some, each, isEmpty, compact } from 'lodash'

import { cloudhelpDelete, cloudhelpPost } from 'Utilities/CloudHelp'

import CSIForm from './CSIForm'

const CSIShow = ({
  hidden,
  csi,
  newCsi,
  updateCSIState,
  usersOptions,
  csiToUpdate,
  problem,
  manageCSITasks
}) => {
  const [errors, setErrors] = useState([])

  const deleteCSI = (csiObject) => {
    if (confirm('Are you sure to delete CSI?')) {
      cloudhelpDelete(csiObject.href)
        .then(() => window.location.reload())
    }
  }

  const editCSI = (csiObject) => {
    newCsi.splice(indexOf(csi, csiObject), 0, csiObject)

    updateCSIState(newCsi)
  }

  const saveCsi = () => {
    const csiFields = ['owner_id', 'description', 'due_date']
    const csiErrors = map(newCsi, (csiObj, index) => {
      const emptyFields = []
      each(csiFields, (field) => { if (!csiObj[field] || csiObj === '') { emptyFields.push(field) } })

      if (csiObj.cloudops_register && isEmpty(csiObj.csi_item_number)) { emptyFields.push('csi_item_number') }
      if (!isEmpty(emptyFields)) { return { index, errors: emptyFields } }
    })

    if (!isEmpty(compact(csiErrors))) {
      setErrors(csiErrors)

      return null
    }

    cloudhelpPost(`/api/problems/${problem.id}/create_and_update`, { csi: newCsi })
      .then(() => window.location.reload())
  }

  const trueFalseIconClass = (condition) => (
    condition ? <Icon type="checkmark-circle" color="green" /> : <Icon type="cross-circle" color="red" />
  )

  if (hidden) { return null }

  return (
    <Card padding={false} allowOverflow>
      {map(csi, csiObject => {
        if (!find(newCsi, ['id', csiObject.id])) {
          return (
            <ContentSectionBlock
              title={`CSI ${csiObject.alt_id}`}
              actions={manageCSITasks ? [
                { text: <span className='mr-2 link'>Edit</span>, onClick: () => editCSI(csiObject) },
                { text: <span className='link--danger'>Delete</span>, onClick: () => deleteCSI(csiObject) }
              ] : []}
            >
              <DetailList
                list={[
                  {
                    title: 'Description',
                    content: csiObject.description
                  },
                  {
                    title: 'Owner',
                    content: csiObject.owner
                  },
                  {
                    title: 'Due date',
                    content: csiObject.due_date_humanized
                  },
                  {
                    title: 'Added to CloudOps CSI Register?',
                    content: trueFalseIconClass(csiObject.cloudops_register)
                  },
                  csiObject.cloudops_register && {
                    title: 'CSI Item Number',
                    content: csiObject.csi_item_number
                  },
                  {
                    title: 'Status',
                    content: csiObject.status_humanized
                  }
                ]}
              />
            </ContentSectionBlock>
          )
        }
      })}
      {manageCSITasks && (
        <ContentSectionBlock>
          <CSIForm userOptions={usersOptions} updateCSIState={value => updateCSIState(value)} csi={newCsi} errors={errors} />
        </ContentSectionBlock>
      )}
      {(some(newCsi) || some(csiToUpdate)) && (
        <ContentSectionBlock>
          <Button onClick={() => saveCsi()}>Save</Button>
        </ContentSectionBlock>
      )}
    </Card>
  )
}

export default CSIShow
